import React from 'react';
import {ReactComponent as Connector} from '../assets/any-cropped (3).svg'
import { get_apps } from '../../../api/api.js';


function Yellowbox({ imageSrc, applink, keyno, applength, lastcheck}) {

    return (
        <div className="tile">
    
    <div className='Cardbox'><div className="yellowbox">
        
        <div className="whitebox"><div className='container'><a target='_blank' href={applink}><img className='applogo' src={imageSrc}/> </a>  </div></div>

        
        
        </div>

        
         
        <Connector className='connectorcss' style={{ visibility: keyno === applength-1 || keyno === lastcheck  ?'hidden' : 'visible' }} />
      


    </div></div>
        );
}

export default Yellowbox;